import { IDataEndPoint, IEntityEndPoints, IFieldOptions, IFormOptions, IGridOptions, IColumnOptions, IEntityOptions } from '@framework/interfaces/IEntity';
import * as app from '@framework/app';
import * as models from '@common/domain/models/WorkOrderDTO';
import { IApiServiceCommand } from '@services/api/api.service';
export class WorkOrderEndPoints implements IEntityEndPoints {
	list?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/workOrder"}, method: "GET" };
	get?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/workOrder/" + serviceCommand.context.entityId}, method: "GET" };
	update?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/workOrder/update/" + serviceCommand.context.entityId}, method: "POST" };
	search?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/workOrder/lazy/"}, method: "POST" };
	pagingTotalCount?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/workOrder/lazyCount/"}, method: "POST" };
	insert?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/workOrder/create"}, method: "POST" };
	delete?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/workOrder/delete/"+ serviceCommand.context.entityId}, method: "POST" };
}

export class WorkOrderFormFields extends Array<IFieldOptions> {
	public id: IFieldOptions = { field: "id" };
	public areaId: IFieldOptions = { field: "areaId" };
	public workOrderNo: IFieldOptions = { field: "workOrderNo" };
	public contractManagerId: IFieldOptions = { field: "contractManagerId" };
	public dateIssued: IFieldOptions = { field: "dateIssued" };
	public functionalLocation: IFieldOptions = { field: "functionalLocation" };
	public functionalLocationDescription: IFieldOptions = { field: "functionalLocationDescription" };
	public contactPersonId: IFieldOptions = { field: "contactPersonId" };
	public contactNo: IFieldOptions = { field: "contactNo" };
	public priorityId: IFieldOptions = { field: "priorityId" };
	public dateScopedOut: IFieldOptions = { field: "dateScopedOut" };
	public dateScopedIn: IFieldOptions = { field: "dateScopedIn" };
	public dateScopeEstimator: IFieldOptions = { field: "dateScopeEstimator" };
	public datestamp: IFieldOptions = { field: "datestamp" };
	public changedBy: IFieldOptions = { field: "changedBy" };
	public status: IFieldOptions = { field: "status" };
	public jobNumberId: IFieldOptions = { field: "jobNumberId" };
	public siteId: IFieldOptions = { field: "siteId" };
	public siteSysProClientId: IFieldOptions = { field: "siteSysProClientId" };
	constructor() {
		super();
		this.push(this.id);
		this.push(this.areaId);
		this.push(this.workOrderNo);
		this.push(this.contractManagerId);
		this.push(this.dateIssued);
		this.push(this.functionalLocation);
		this.push(this.functionalLocationDescription);
		this.push(this.contactPersonId);
		this.push(this.contactNo);
		this.push(this.priorityId);
		this.push(this.dateScopedOut);
		this.push(this.dateScopedIn);
		this.push(this.dateScopeEstimator);
		this.push(this.datestamp);
		this.push(this.changedBy);
		this.push(this.status);
		this.push(this.jobNumberId);
		this.push(this.siteId);
		this.push(this.siteSysProClientId);
	}
}

export class WorkOrderForm implements IFormOptions {
	protected workOrderFormName: string = "workOrderForm";
	protected workOrderFormModel: models.WorkOrderDTO = new models.WorkOrderDTO();
	protected workOrderFormEndPoints: WorkOrderEndPoints = new WorkOrderEndPoints();
	protected workOrderFormFields: WorkOrderFormFields = new WorkOrderFormFields();
	public get name(): string { return this.workOrderFormName };
	public get model(): models.WorkOrderDTO { return this.workOrderFormModel };
	public get endPoints(): IEntityEndPoints { return this.workOrderFormEndPoints };
       public set endPoints(workOrderEndPoints: IEntityEndPoints) {
		this.workOrderFormEndPoints = workOrderEndPoints;
	};
	public get dataEndPoint(): IDataEndPoint { return this.endPoints.get };
	public get fields(): WorkOrderFormFields { return this.workOrderFormFields };
}

export class WorkOrderListColumns extends Array<IColumnOptions> {
	public id: IColumnOptions = { field: "id" };
	public areaId: IColumnOptions = { field: "areaId" };
	public workOrderNo: IColumnOptions = { field: "workOrderNo" };
	public contractManagerId: IColumnOptions = { field: "contractManagerId" };
	public dateIssued: IColumnOptions = { field: "dateIssued", template: function (fldValue) { return (new Date(fldValue)["shortDate"]()).toString(); } };
	public functionalLocation: IColumnOptions = { field: "functionalLocation" };
	public functionalLocationDescription: IColumnOptions = { field: "functionalLocationDescription" };
	public contactPersonId: IColumnOptions = { field: "contactPersonId" };
	public contactNo: IColumnOptions = { field: "contactNo" };
	public priorityId: IColumnOptions = { field: "priorityId" };
	public dateScopedOut: IColumnOptions = { field: "dateScopedOut", template: function (fldValue) { return (new Date(fldValue)["shortDate"]()).toString(); } };
	public dateScopedIn: IColumnOptions = { field: "dateScopedIn", template: function (fldValue) { return (new Date(fldValue)["shortDate"]()).toString(); } };
	public dateScopeEstimator: IColumnOptions = { field: "dateScopeEstimator", template: function (fldValue) { return (new Date(fldValue)["shortDate"]()).toString(); } };
	public datestamp: IColumnOptions = { field: "datestamp", template: function (fldValue) { return (new Date(fldValue)["shortDate"]()).toString(); } };
	public changedBy: IColumnOptions = { field: "changedBy" };
	public status: IColumnOptions = { field: "status" };
	public jobNumberId: IColumnOptions = { field: "jobNumberId" };
	public siteId: IColumnOptions = { field: "siteId" };
	public siteSysProClientId: IColumnOptions = { field: "siteSysProClientId" };
	constructor() {
		super();
		this.push(this.id);
		this.push(this.areaId);
		this.push(this.workOrderNo);
		this.push(this.contractManagerId);
		this.push(this.dateIssued);
		this.push(this.functionalLocation);
		this.push(this.functionalLocationDescription);
		this.push(this.contactPersonId);
		this.push(this.contactNo);
		this.push(this.priorityId);
		this.push(this.dateScopedOut);
		this.push(this.dateScopedIn);
		this.push(this.dateScopeEstimator);
		this.push(this.datestamp);
		this.push(this.changedBy);
		this.push(this.status);
		this.push(this.jobNumberId);
		this.push(this.siteId);
		this.push(this.siteSysProClientId);
	}
}

export class WorkOrderList implements IGridOptions {
	protected workOrderListName: string = "workOrderList";
	protected workOrderListModel: models.WorkOrderDTO = new models.WorkOrderDTO();
	protected workOrderListEndPoints: WorkOrderEndPoints = new WorkOrderEndPoints();
	protected workOrderListColumns: WorkOrderListColumns = new WorkOrderListColumns();
	public workOrderForm: WorkOrderForm = new WorkOrderForm();
	public get name(): string { return this.workOrderListName };
	public get model(): models.WorkOrderDTO { return this.workOrderListModel };
	public get endPoints(): IEntityEndPoints { return this.workOrderListEndPoints };
	public set endPoints(workOrderEndPoints: IEntityEndPoints) {
		this.workOrderListEndPoints = workOrderEndPoints;
		this.workOrderForm.endPoints = this.endPoints;
	};
	public get dataEndPoint(): IDataEndPoint { return this.endPoints.list };
	public get columns(): WorkOrderListColumns { return this.workOrderListColumns };
}

export class WorkOrderEntity implements IEntityOptions {
	protected workOrderEntityName: string = "workOrderEntity";
	protected workOrderEntityModel: models.WorkOrderDTO = new models.WorkOrderDTO();
	protected workOrderEntityEndPoints: WorkOrderEndPoints = new WorkOrderEndPoints();
	protected workOrderEntityList: WorkOrderList = new WorkOrderList();
	public get name(): string { return this.workOrderEntityName };
	public get model(): models.WorkOrderDTO { return this.workOrderEntityModel };
	public get endPoints(): IEntityEndPoints { return this.workOrderEntityEndPoints };
	public set endPoints(workOrderEndPoints: IEntityEndPoints) {
		this.workOrderEntityEndPoints = workOrderEndPoints;
		this.grid.endPoints = this.endPoints;
	};
	public get grid(): WorkOrderList { return this.workOrderEntityList };
	public get form(): WorkOrderForm { return this.grid.workOrderForm };
	constructor(name?: string) {
		if (name) this.workOrderEntityName = name;
		this.endPoints = this.workOrderEntityEndPoints;
	}
};
//export class WorkOrderGeneratedForm extends MfGeneratedFormComponent {
 // protected detailPageComponentForm: WorkOrderForm = new WorkOrderForm();
//};

//export class WorkOrderListPageComponent extends ListPageComponent {
  //protected listPageComponentList: WorkOrderList = new  WorkOrderList();
  //protected showFilterColOnTable: boolean = true;
//};

//export class WorkOrderBlade extends MfBladeComponent {
  //protected detailComponents: Array<IDetailComponent> = [ { index: 0, displayName: "Properties", component: WorkOrderGeneratedForm}];
//};

//export class WorkOrderListBlade extends MfBladeComponent {
 // protected detailComponents: Array<IDetailComponent> = [ { index: 0, displayName: "Properties", component: WorkOrderListPageComponent, isMenuHidden: true }];
//};

